/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RepairOrder,
  WorkInProgress,
} from '../models';
import {
    RepairOrderFromJSON,
    RepairOrderToJSON,
    WorkInProgressFromJSON,
    WorkInProgressToJSON,
} from '../models';

export interface GetWorkInProgressRequest {
    customerId: string;
    xPcsImpersonatedUser?: string;
}

export interface GetWorkInProgressRepairOrdersRequest {
    id: string;
    xPcsImpersonatedUser?: string;
}

/**
 * 
 */
export class WorkInProgressApi extends runtime.BaseAPI {

    /**
     * Get a list of Work In Progress
     * Get Work In Progress
     */
    async getWorkInProgressRaw(requestParameters: GetWorkInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkInProgress>>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getWorkInProgress.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/workInProgress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkInProgressFromJSON));
    }

    /**
     * Get a list of Work In Progress
     * Get Work In Progress
     */
    async getWorkInProgress(requestParameters: GetWorkInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkInProgress>> {
        const response = await this.getWorkInProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of Repair Orders for the Work In Progress
     * Get Work In Progress Repair Orders
     */
    async getWorkInProgressRepairOrdersRaw(requestParameters: GetWorkInProgressRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RepairOrder>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getWorkInProgressRepairOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-pcs-impersonated-user"] = this.configuration.apiKey("x-pcs-impersonated-user"); // api-impersonation authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/workInProgress/{id}/repairOrders`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RepairOrderFromJSON));
    }

    /**
     * Get a list of Repair Orders for the Work In Progress
     * Get Work In Progress Repair Orders
     */
    async getWorkInProgressRepairOrders(requestParameters: GetWorkInProgressRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RepairOrder>> {
        const response = await this.getWorkInProgressRepairOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
